import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { addressLines } from "./orderMeta";

export function AddressForm({ order, onDone, onCancel, admin = false }) {
  const a = order.shipping_address && !order.shipping_address.redacted ? order.shipping_address : {};
  const [f, setF] = useState({ name: a.name || order.buyer_name || "", line1: a.line1 || "", line2: a.line2 || "", city: a.city || "", postal_code: a.postal_code || "", reason: "" });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.put(`/orders/${order.id}/shipping-address`, f); toast.success("Morada guardada"); onDone?.(); }
    catch (err) { toast.error(formatApiError(err?.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const inp = "w-full px-3 py-2 rounded-lg border border-zinc-200 text-sm";
  return (
    <form onSubmit={save} data-testid={`address-form-${order.order_number}`} className="mt-2 p-3 rounded-xl border border-zinc-200 bg-zinc-50 space-y-2">
      <div className="text-xs font-semibold">Morada de entrega (Reino Unido)</div>
      <input data-testid="address-name" className={inp} placeholder="Nome do destinatário" value={f.name} onChange={upd("name")} required />
      <input data-testid="address-line1" className={inp} placeholder="Morada (linha 1)" value={f.line1} onChange={upd("line1")} required />
      <input data-testid="address-line2" className={inp} placeholder="Linha 2 (opcional)" value={f.line2} onChange={upd("line2")} />
      <div className="grid grid-cols-2 gap-2">
        <input data-testid="address-city" className={inp} placeholder="Cidade" value={f.city} onChange={upd("city")} required />
        <input data-testid="address-postcode" className={inp} placeholder="Código postal" value={f.postal_code} onChange={upd("postal_code")} required />
      </div>
      {admin && <input data-testid="address-reason" className={inp} placeholder="Motivo da correção (obrigatório)" value={f.reason} onChange={upd("reason")} required />}
      <div className="flex gap-2">
        <button data-testid="address-save" disabled={busy} className="flex-1 py-2 rounded-lg bg-black text-white text-xs font-bold disabled:opacity-50">Guardar morada</button>
        {onCancel && <button type="button" onClick={onCancel} className="px-3 py-2 rounded-lg border border-zinc-200 text-xs">Cancelar</button>}
      </div>
    </form>
  );
}

export function AddressBlock({ o, testid }) {
  const lines = addressLines(o.shipping_address);
  if (o.shipping_address?.redacted) return <p className="text-[11px] text-zinc-400">Morada removida (conta eliminada)</p>;
  if (!lines.length) return <p data-testid={testid} className="text-[11px] text-orange-700 font-semibold">Morada de entrega em falta</p>;
  return <address data-testid={testid} className="not-italic text-[11px] text-zinc-700 leading-snug">{lines.map((l, i) => <div key={i}>{l}</div>)}</address>;
}
